exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tat-dashboard-container{padding:20px}.gap-1{gap:.25rem}.gap-2{gap:.5rem}.table-responsive{overflow-x:auto}.badge-sm{font-size:.5625rem;padding:.25rem .5rem}.b-table td{vertical-align:top;padding:.5rem;font-size:.5625rem}.row-delayed,.row-on-track{border-left:4px solid #6c757d!important;background-color:#f8f9fa!important}.text-wrap{word-wrap:break-word;white-space:normal}.b-table,.b-table *,.b-table td,.b-table th,.badge,.badge-sm,.font-weight-bold,.text-muted,h6,small{font-size:.5625rem!important}.badge-secondary{background-color:#6c757d!important;color:#fff!important}.badge-light{background-color:#f8f9fa!important}.badge-light,.text-danger,.text-info,.text-primary,.text-success,.text-warning{color:#495057!important}@media (max-width:768px){.badge-sm{font-size:.5625rem;padding:.2rem .4rem}.b-table td{padding:.25rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5db33594","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/ulip/TATDashboard.vue
// module id = 1636
// module chunks = 0